import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import MainServiceSection from '../ComponentsGlobals/MainServiceSection/MainServiceSection';
import GallerySection from '../ComponentsGlobals/GallerySection/GallerySection';
import OverlaySection from '../ComponentsGlobals/OverlaySection/OverlaySection';
import ServicesOverviewSection from '../ComponentsGlobals/ServicesOverviewSection/ServicesOverviewSection';
import FeatureGridSection from '../ComponentsGlobals/FeatureGridSection/FeatureGridSection';
import { servicesConfig } from '../../../../json/sections/services';
import Banner from '../../../Layout/Banner/Banner';

const ServicePage = () => {
    const { slug } = useParams();
    const cfg = servicesConfig[slug];

    if (!cfg) {
        return <Navigate to="/404" replace />;
    }

    const {
        mainConfig,
        gallery,
        overlay,
        overview,
        features
    } = cfg;

    return (
        <>
            <Banner />
            {mainConfig && (
                <MainServiceSection config={mainConfig} />
            )}

            {gallery && (
                <GallerySection data={gallery} />
            )}

            {overlay && (
                <OverlaySection data={overlay} />
            )}

            {overview && (
                <ServicesOverviewSection data={overview} />
            )}

            {features && (
                <FeatureGridSection data={features} />
            )}
        </>
    );
};

export default ServicePage;
